module.exports = __webpack_public_path__ + "new-5455795b/template-7-cdf52243d4486bb19fea9ae5d857f71c.jpg";